const TAB_IDS = {
  CONTRACT: 'tab_contract',
  DOCUMENTS: 'tab_documents',
  BANK: 'tab_bank',
  ACCOUNT: 'tab_account',
};

TAB_IDS.DEFAULT = TAB_IDS.CONTRACT;

export { TAB_IDS };
